"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canRequestHealth = exports.healthVersions = exports.healthToolLabel = exports.healthContentNote = exports.healthRetentionNote = exports.SECRET_MAX_BYTES = exports.secretLabel = exports.entryGroups = exports.toggleMailbox = exports.mailboxChoices = exports.knownMailboxes = exports.driveOptions = exports.psDbOptions = exports.repoOptions = exports.noLevels = exports.assignableEntries = exports.roleLabel = exports.localCopyExplanation = exports.manualExplanation = exports.statusViews = void 0;
exports.availableActions = availableActions;
exports.describeGithub = describeGithub;
exports.describeDrive = describeDrive;
exports.describeFailure = describeFailure;
exports.describeOutcome = describeOutcome;
exports.confirmationContent = confirmationContent;
exports.describeLevels = describeLevels;
exports.groupKey = groupKey;
exports.secretsState = secretsState;
exports.secretInputError = secretInputError;
exports.takeSecretConfirmation = takeSecretConfirmation;
exports.formatHealthDate = formatHealthDate;
exports.healthColumn = healthColumn;
exports.statusViews = {
    INVITED: { label: "Zaproszony", variant: "warning" },
    ACTIVE: { label: "Aktywny", variant: "success" },
    BLOCKED: { label: "Zablokowany", variant: "secondary" },
    REVOKED: { label: "Odebrany", variant: "dark" },
};
exports.manualExplanation = "Nadane ręcznie przed uruchomieniem modułu. Moduł nie zdejmuje takiego dostępu - zmień go ręcznie na GitHubie i na Dysku.";
exports.localCopyExplanation = "To, co już pobrała na swój komputer (kopia wiedzy, skille), zostaje - zdalnego kasowania nie ma.";
const actionLabels = { invite: "Zaproszenie", block: "Blokada", unblock: "Odblokowanie", revoke: "Odebranie", assign: "Przypisanie konta GitHub" };
function availableActions(entry) {
    if (entry.isGrantedManually)
        return [];
    const block = { action: "block", label: "Zablokuj", confirm: true };
    const revoke = { action: "revoke", label: "Odbierz", confirm: true };
    const remaining = entry.githubInvitationId != null || !!entry.drivePermissionId;
    switch (entry.statusCode) {
        case "INVITED": return [{ action: "invite", label: "Ponów zaproszenie" }, block, revoke];
        case "ACTIVE": return [block, revoke];
        case "BLOCKED": return [{ action: "unblock", label: "Odblokuj" }, revoke, ...(remaining ? [{ action: "block", label: "Ponów blokadę" }] : [])];
        case "REVOKED": return remaining ? [{ action: "revoke", label: "Ponów odebranie" }] : [];
    }
}
// Nazwa roli z PS jest kodem systemowym; na ekranie kierownika pokazujemy polską nazwę.
const roleLabel = (systemRoleName) => systemRoleName === "ENVI_MANAGER" ? "kierownik" : systemRoleName === "ENVI_EMPLOYEE" ? "pracownik" : systemRoleName || "brak roli";
exports.roleLabel = roleLabel;
function describeGithub(entry) {
    return entry.githubLogin || (entry.statusCode === "INVITED" && entry.githubInvitationId != null ? "zaproszenie czeka" : "niepowiązane");
}
function describeDrive(entry) {
    if (entry.drivePermissionId)
        return "jest";
    if (entry.isGrantedManually)
        return "nadane ręcznie";
    // Brak numeru w stanach nadania oznacza brak zapisu, w stanach odebrania - zdjęty dostęp.
    return entry.statusCode === "INVITED" || entry.statusCode === "ACTIVE" ? "brak zapisu" : "zdjęty";
}
function describeFailure(status, message) {
    switch (status) {
        case 503: return "Funkcja nieskonfigurowana - serwer PS nie ma tokenu GitHub do zapraszania. Nic nie zostało zmienione.";
        case 502: return `${message} Nic nie zostało zmienione.`.trim();
        case 409:
        case 422:
        case 400: return message || `Nie udało się wykonać operacji (kod ${status}).`;
        case 401:
        case 403: return "Nie masz uprawnienia do zarządzania dostępem do Second Brain.";
        case 0: return "Brak połączenia z serwerem PS. Spróbuj ponownie.";
        default: return `Nie udało się wykonać operacji (kod ${status}).`;
    }
}
function describeOutcome(action, personLabel, result, note) {
    return result === "PARTIAL"
        ? { variant: "warning", message: `Wykonano tylko częściowo: ${actionLabels[action]} - ${personLabel}. ${note} Powtórz operację, a jeśli dostęp nadal pozostaje, zdejmij go ręcznie na GitHubie i na Dysku.` }
        : { variant: "success", message: `Wykonano: ${actionLabels[action]} - ${personLabel}.${note ? ` ${note}` : ""}` };
}
function confirmationContent(action, entry) {
    return {
        title: action === "block" ? "Zablokować dostęp do Second Brain?" : "Odebrać dostęp do Second Brain na stałe?",
        paragraphs: [
            `Osoba: ${entry.name} ${entry.surname} - ${entry.systemEmail || "brak adresu"}.`,
            "Osoba zostanie usunięta z organizacji GitHub (albo anulowane zostanie jej oczekujące zaproszenie) i straci dostęp do dysku SB.ENVI, więc nie pobierze już nowej wiedzy.",
            action === "block" ? 'Blokadę można cofnąć przyciskiem "Odblokuj". Osoba dostanie wtedy nowe zaproszenie na GitHubie i musi je przyjąć.' : "Odebranie kończy dostęp na stałe; ponowne dopuszczenie to nowe zaproszenie.",
            exports.localCopyExplanation,
        ],
    };
}
const assignableEntries = (entries) => entries.filter(entry => (entry.statusCode === "INVITED" || entry.statusCode === "ACTIVE") && entry.githubLogin === null && !entry.isGrantedManually);
exports.assignableEntries = assignableEntries;
exports.noLevels = { repos: "none", psDb: "none", drive: "none", mail: [] };
exports.repoOptions = [["none", "brak"], ["read", "odczyt"], ["write", "zapis"]];
exports.psDbOptions = [["none", "brak"], ["ro", "odczyt"], ["rw", "zapis"]];
exports.driveOptions = [["none", "brak"], ["connector", "konektor"]];
const optionLabel = (options, value) => options.find(([key]) => key === value)?.[1] ?? value;
function describeLevels(entry) {
    const levels = entry.levels ?? exports.noLevels;
    return {
        repos: optionLabel(exports.repoOptions, levels.repos), psDb: optionLabel(exports.psDbOptions, levels.psDb),
        drive: optionLabel(exports.driveOptions, levels.drive), mail: levels.mail.length ? levels.mail.join(", ") : "brak",
    };
}
// Skrzynki znane z konfiguracji poczty firmowej; inne kody z bazy też zostają widoczne w panelu.
exports.knownMailboxes = ["marek", "faktury", "chocianow-ik", "wp"];
const mailboxChoices = (selected) => [...exports.knownMailboxes, ...selected.filter(code => !exports.knownMailboxes.includes(code))];
exports.mailboxChoices = mailboxChoices;
const toggleMailbox = (mail, code, on) => on ? (mail.includes(code) ? mail : [...mail, code]) : mail.filter(item => item !== code);
exports.toggleMailbox = toggleMailbox;
// Grupy tabeli: administratorzy SB (znacznik CanManageSbAccess) przed pracownikami i zaproszonymi;
// zablokowani i odebrani mają własną grupę, żeby nie znikali z ekranu.
exports.entryGroups = [
    { key: "admin", label: "Administratorzy SB", hint: "nadają dostępy" },
    { key: "staff", label: "Pracownicy", hint: "" },
    { key: "invited", label: "Zaproszeni", hint: "jeszcze nie przyjęli zaproszenia" },
    { key: "closed", label: "Zablokowani i odebrani", hint: "" },
];
function groupKey(entry) {
    if (entry.statusCode === "INVITED")
        return "invited";
    if (entry.statusCode !== "ACTIVE")
        return "closed";
    return entry.canManageSb ? "admin" : "staff";
}
// Hasła (SBD-2). Które hasła należą się osobie, rozstrzyga PS (secretsExpected); tu tylko podpis i stan.
const secretLabel = (name) => name === "baza-ps" ? "baza PS" : name.startsWith("poczta-") ? `poczta: ${name.slice("poczta-".length)}` : name;
exports.secretLabel = secretLabel;
function secretsState(entry) {
    const expected = entry.secretsExpected ?? [], given = (entry.secretsGiven ?? []).filter(name => expected.includes(name));
    if (!expected.length)
        return { text: "—", tone: "off" };
    return { text: `${given.length} z ${expected.length}`, tone: given.length === expected.length ? "ok" : "warn" };
}
/** RSA-OAEP SHA-256 z kluczem 2048 bit mieści najwyżej 190 bajtów tekstu (UTF-8). */
exports.SECRET_MAX_BYTES = 190;
function secretInputError(value) {
    if (!value)
        return "Wpisz hasło.";
    return new TextEncoder().encode(value).length > exports.SECRET_MAX_BYTES ? `Hasło jest za długie (najwyżej ${exports.SECRET_MAX_BYTES} bajtów).` : null;
}
function takeSecretConfirmation(entry, name) {
    return {
        title: `Odebrać hasło: ${(0, exports.secretLabel)(name)}?`,
        paragraphs: [
            `Osoba: ${entry.name} ${entry.surname} - ${entry.systemEmail || "brak adresu"}.`,
            "Szyfr zostanie usunięty z PS, więc komputer pracownika nie pobierze go ponownie.",
            "Jeśli komputer już go pobrał, nie da się tego cofnąć - zmień hasło u źródła (w poczcie albo w bazie).",
        ],
    };
}
exports.healthRetentionNote = "Komputer to ostatni raport instalatora SB u pracownika, wysyłany raz dziennie. Raport starszy niż 7 dni jest szary.";
exports.healthContentNote = "Raport zawiera tylko wersje, stan narzędzi i krótkie opisy błędów. Bez haseł i bez treści poczty.";
const two = (value) => String(value).padStart(2, "0");
/** "dziś 08:12" dla bieżącego dnia, inaczej "18.10 17:40". */
function formatHealthDate(iso, now = new Date()) {
    const date = new Date(iso);
    if (Number.isNaN(date.getTime()))
        return "";
    const time = `${two(date.getHours())}:${two(date.getMinutes())}`;
    return date.toDateString() === now.toDateString() ? `dziś ${time}` : `${two(date.getDate())}.${two(date.getMonth() + 1)} ${time}`;
}
function healthColumn(entry, now = new Date()) {
    const health = entry.health;
    if (!health)
        return { text: "nie zainstalowano", tone: "off", date: null };
    const date = formatHealthDate(health.reportedAt, now);
    if (health.stale)
        return { text: "brak raportu", tone: "off", date };
    return health.state === "ok" ? { text: "działa", tone: "ok", date } : { text: "błąd", tone: "bad", date };
}
const healthToolLabel = (name) => name === "baza-ps" ? "baza PS" : name.startsWith("poczta-") ? `poczta: ${name.slice("poczta-".length)}` : name;
exports.healthToolLabel = healthToolLabel;
const healthVersions = (health, now = new Date()) => `SB ${health.sbVersion ?? "?"} · instalator ${health.installerVersion ?? "?"} · raport ${formatHealthDate(health.reportedAt, now)}`;
exports.healthVersions = healthVersions;
const canRequestHealth = (entry) => entry.statusCode === "INVITED" || entry.statusCode === "ACTIVE";
exports.canRequestHealth = canRequestHealth;
